import { graphql } from "react-relay";

export const AddJiraInstanceMutation = graphql`
  mutation AddJiraInstanceMutation($input: AddJiraInstanceInput!) {
    addJiraInstance(input: $input) {
      jiraInstance {
        clientId
        defaultSpace {
          key
          name
        }
        defaultWorkType {
          name
        }
        error
        id
        issueLimitHard
        issueLimitSoft
        name
        spaces {
          ...JiraInstanceDefaultsFields_spaces
        }
        spacesUpdated
        updatePending
        url
        username
        uuid
      }
      problems {
        message
      }
    }
  }
`;
